import { useState, useEffect } from 'react';
import './CookieBanner.css';

function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    } else if (consent === 'accepted') {
      // Load analytics if previously accepted
      loadAnalytics();
    }
  }, []);

  const loadAnalytics = () => {
    // Load PostHog script dynamically
    if (!window.posthog.__loaded) {
      const script = document.createElement('script');
      script.innerHTML = `
        !(function (t, e) {
          var o, n, p, r;
          e.__SV ||
            ((window.posthog = e),
            (e._i = []),
            (e.init = function (i, s, a) {
              function g(t, e) {
                var o = e.split(".");
                2 == o.length && ((t = t[o[0]]), (e = o[1])),
                (t[e] = function () {
                  t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                });
              }
              ((p = t.createElement("script")).type = "text/javascript"),
              (p.crossOrigin = "anonymous"),
              (p.async = !0),
              (p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js"),
              (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
              var u = e;
              for (
                void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
                u.people = u.people || [],
                u.toString = function (t) {
                  var e = "posthog";
                  return ("posthog" !== a && (e += "." + a), t || (e += " (stub)"), e);
                },
                u.people.toString = function () {
                  return u.toString(1) + ".people (stub)";
                },
                o = "init me ws ys ps bs capture je Di ks register register_once register_for_session unregister unregister_for_session Ps getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Es $s createPersonProfile Is opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Ss debug xs getPageViewId captureTraceFeedback captureTraceMetric".split(" "),
                n = 0;
                n < o.length;
                n++
              )
                g(u, o[n]);
              e._i.push([i, s, a]);
            }),
            (e.__SV = 1));
        })(document, window.posthog || []);
        window.posthog.init("phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs", {
          api_host: "https://us.i.posthog.com",
          person_profiles: "identified_only",
          session_recording: {
            recordCrossOriginIframes: true,
            capturePerformance: false,
          },
        });
      `;
      document.head.appendChild(script);
      window.posthog.__loaded = true;
    }
  };

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
    loadAnalytics();
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
    // Don't load analytics
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner" data-testid="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <h3>Cookies & Datenschutz</h3>
          <p>
            Wir verwenden Cookies und ähnliche Technologien, um die Nutzung unserer Website zu analysieren 
            und deine Erfahrung zu verbessern. Mit deiner Zustimmung verwenden wir Analytics-Tools (PostHog). 
            Zudem nutzen wir eingebettete Inhalte von YouTube und Google Maps, die eigene Cookies setzen können.
            <br />
            <a href="/datenschutz" target="_blank" rel="noopener noreferrer">
              Mehr Informationen in unserer Datenschutzerklärung
            </a>
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button 
            onClick={handleDecline} 
            className="cookie-btn cookie-btn-decline"
            data-testid="cookie-decline-button"
          >
            Ablehnen
          </button>
          <button 
            onClick={handleAccept} 
            className="cookie-btn cookie-btn-accept"
            data-testid="cookie-accept-button"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
